import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { sendTemporalSignUpExghangeRequest } from '../../utils/api/accountApi';
import { genericErrorMessage } from '../../utils/lang/commonErrors';

import EnterLayout from '../../components/layout/EnterLayout';
import Alert from '../../components/common/Alert';
import Loader from '../../components/common/Loader';

import styles from './SignUpConfirmRoute.scss';

const SignUpConfirmRoute = () => {
  const intl = useIntl();
  const history = useHistory();

  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setError(
        intl.formatMessage({
          id: 'signUpComplete.error.missingToken',
          defaultMessage: 'Oops, something went wrong. \nBe a friend, open the link in the email one more time.',
          description: 'Complete Sign Up page error, shown when the URL doesn’t have required token param',
        }),
      );
    } else {
      sendTemporalSignUpExghangeRequest(token).then(
        () => history.push('/profile'),
        (err) => {
          console.error(err);
          setError(intl.formatMessage(genericErrorMessage));
        },
      );
    }
  }, []);

  const footerChild = error ? <span className={styles.error}>{error}</span> : <Loader colored />;

  return (
    <EnterLayout verticalPaddings={[70, 80]}>
      <Alert
        title={intl.formatMessage({
          id: 'signUpComplete.title',
          defaultMessage: 'We’re creating your account',
          description:
            'Title of the page, where user’s account gets created by the link from email, no action required, just wait',
        })}
        description={intl.formatMessage({
          id: 'signUpComplete.subtitle',
          defaultMessage: 'It’ll be ready in no time!',
          description:
            'Subtitle of the page, where user’s account gets created by the link from email, no action required, just wait',
        })}
        footerChild={footerChild}
      />
    </EnterLayout>
  );
};

export default SignUpConfirmRoute;
